export interface IAppBasic {
  appName: string
  appType: 'Quick Online Courses' | 'Face to Face Discussions' | 'Full Intro Training'
  laboratorium: string
  generalCondition: string
  doctor: string
  specialist: string
  medicalExpense?: number
  upgradeRoom?: string
  reason?: string
  isAPS?: boolean
  costSaving?: number
  remarksCostSaving?: string
  pulse: string
  respiratory: string
  bloodPressure: string
  temperature: string
  supporting: string
  followUp: string
  treatment: string
  remarks?: string
  icd10: string
  icd102?: string
  icd103?: string
  icd104?: string
  files?: File[]
}

export type TAppFramework = 'HTML5' | 'ReactJS' | 'Angular' | 'Vue'

export interface IAppDatabase {
  databaseName: string
  databaseSolution: 'MySQL' | 'Firebase' | 'DynamoDB'
}

export type TAppStorage = 'Basic Server' | 'AWS' | 'Google'

export interface ICreateAppData {
  appBasic: IAppBasic
  appFramework: TAppFramework
  appDatabase: IAppDatabase
  appStorage: TAppStorage
  appFiles: {
    files: File[];
  }
}

export const defaultCreateAppData: ICreateAppData = {
  appBasic: {
    appName: '',
    appType: 'Quick Online Courses',
    laboratorium: '',
    generalCondition: '',
    doctor: '',
    specialist: '',
    medicalExpense: 0,
    upgradeRoom: '',
    reason: '',
    isAPS: false,
    costSaving: 0,
    remarksCostSaving: '',
    pulse: '',
    respiratory: '',
    bloodPressure: '',
    temperature: '',
    supporting: '',
    followUp: '',
    treatment: '',
    remarks: '',
    icd10: '',
    icd102: '',
    icd103: '',
    icd104: '',
    files: [],
  },
  appFramework: 'HTML5',
  appDatabase: { databaseName: 'db_name', databaseSolution: 'MySQL' },
  appStorage: 'Basic Server',
  appFiles: {
    files: [],
  }
}

export type StepProps = {
  data: ICreateAppData
  updateData: (fieldsToUpdate: Partial<ICreateAppData>) => void
  hasError: boolean,
  claimDetails?: any
}